import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss";
import React, {useEffect} from "react";
import Loading from "../../../../components/loading/op-loading";
import {useQuery} from "../../../../hooks/common";

export default props => {
    useStyles(classes)
    const query = useQuery()
    useEffect(async () => {
        // console.log("@query",query);
        const {redirect_status,transactionId,payment_intent,payment_intent_client_secret,payMethod}=query
        // console.log("@redirect_status",redirect_status);
        // if(redirect_status=="failed"){
        //     window.location.href="/cart/checkout"
        //     return
        // }
        // window.location.href=`/order-confirm/${transactionId}?transactionId=${transactionId}`
        window.location.href=`/api/geekopay/success/web?transactionId=${transactionId}&payMethod=${payMethod}&redirect_status=${redirect_status}&payment_intent=${payment_intent}`
    },[]);
    return <div className={classes.Container}><Loading /></div>;
}